import { Action, Reducer } from "redux";
import { AppThunkAction, remoteActions } from ".";

export const IMPORTED_USED_CHANGED = "IMPORTED_USED_CHANGED";
export const IMPORTED_USED_INVALID = "IMPORTED_USED_INVALID";
export const IMPORTED_USED_VALID = "IMPORTED_USED_VALID";

export interface ImportedUsedValue {
  value: boolean;
  text: string;
}

export interface ImportedUsedState {
  title: string;
  /**
   * TRUE means car is imported as used!
   */
  selected?: boolean;
  questionVisible: boolean;
  values: ImportedUsedValue[];
  description?: { title: string; text: string };
  requiredErrorMessage?: string;
  showError: boolean;
}

// for dev. purposes
export const defaults: ImportedUsedState = {
  // localize;
  title: "Är bilen importerad begagnad?",
  questionVisible: true,
  selected: false,
  values: [
    {
      value: true,
      text: "Ja",
    },
    {
      value: false,
      text: "Nej",
    },
  ],
  requiredErrorMessage: "Vi behöver veta om bilen är importerad begagnad eller inte.",
  showError: false,
};

export type ImportedUsedAction = {
  type: typeof IMPORTED_USED_CHANGED | typeof IMPORTED_USED_INVALID | typeof IMPORTED_USED_VALID;
  payload: { value: boolean | undefined };
};

export const reducer: Reducer<ImportedUsedState> = (state: ImportedUsedState = defaults, input: Action): ImportedUsedState => {
  const action = input as ImportedUsedAction;

  switch (action?.type) {
    case IMPORTED_USED_CHANGED:
      const newValue = action.payload.value;
      if (newValue === null) {
        return state;
      }
      return { ...state, selected: newValue, showError: false };
    case IMPORTED_USED_INVALID: {
      return {
        ...state,
        showError: true,
      };
    }

    case IMPORTED_USED_VALID: {
      return {
        ...state,
        showError: false,
      };
    }

    default:
      return state;
  }
};

export const actions = {
  importedUsedChanged:
    (value: unknown): AppThunkAction<ImportedUsedAction | AppThunkAction<{}>> =>
    dispatch => {
      dispatch({
        type: IMPORTED_USED_CHANGED,
        payload: { value: value as boolean },
      });

      dispatch(remoteActions.requestPriceData()); //TODO fix
    },
};
